<template>
  <div class="wrapper">
    <div class="in-card">
      <div class='tab-wrap-inside orange'>
        <div class="tab-btn">
          <span :class="statisticPeriod === 'month' ? 'active' : ''" @click="changeStats('month')">当月</span>
          <span :class="statisticPeriod === 'season' ? 'active' : ''" @click="changeStats('season')">季度</span>
          <span :class="statisticPeriod === 'annual' ? 'active' : ''" @click="changeStats('annual')">年度</span>
        </div>
      </div>
      <div class="in-total">
        <p class="total-name">进项总额（元）</p>
        <p class="total-money">{{convertNumber(inStats.totalAmount) || '0.00'}}</p>
      </div>
      <div class="in-detail">
        <div>
          <p>税额（元）</p>
          <p>{{convertNumber(inStats.totalTaxAmount)}}</p>
        </div>
        <div>
          <p>开票张数（张）</p>
          <p>{{inStats.totalNum || 0}}</p>
        </div>
      </div>
    </div>
    <Chart :data-source="1"/>
  </div>
</template>

<script>
import {
  Row,
  Col
} from 'vant'
import { ConvertNumber } from '@utils/basicUtil'
import { officialAccountRequest } from '@services'
import moment from 'moment'
import Chart from './Chart'
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    Chart
  },
  props: {},
  data () {
    return {
      statisticPeriod: 'month',
      inStats: {
        totalAmount: 0,
        totalNum: 0,
        totalTaxAmount: 0
      },
      inDataSource: {
        currMonthStatistics: {},
        quarterStatistics: {},
        yearStatistics: {}
      }
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.getInData('month')
    this.getInData('season')
    this.getInData('annual')
  },
  activated () {},
  updated () {},
  methods: {
    changeStats (period) {
      this.statisticPeriod = period
      if (period === 'month') {
        this.inStats = this.inDataSource.currMonthStatistics
      }
      if (period === 'season') {
        this.inStats = this.inDataSource.quarterStatistics
      }
      if (period === 'annual') {
        this.inStats = this.inDataSource.yearStatistics
      }
    },
    convertNumber (data) {
      return ConvertNumber(data) || '0.00'
    },
    async getInData (period) {
      let obj = {
        'month': {
          startTime: moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
        },
        'season': {
          startTime: moment().startOf('quarter').format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().endOf('quarter').format('YYYY-MM-DD HH:mm:ss')
        },
        'annual': {
          startTime: moment().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().endOf('year').format('YYYY-MM-DD HH:mm:ss')
        }
      }
      let params = {
        ...obj[period]
      }
      const data = await officialAccountRequest.weChat.getTicketStatistics(params)
      if (data.success) {
        let name = ''
        if (period === 'month') {
          name = 'currMonthStatistics'
        } else if (period === 'season') {
          name = 'quarterStatistics'
        } else if (period === 'annual') {
          name = 'yearStatistics'
        }
        this.inDataSource = {
          ...this.inDataSource,
          [name]: {
            ...this.inDataSource[name],
            totalAmount: data.result.sumAmountWithTax,
            totalNum: data.result.ticketCounts,
            totalTaxAmount: data.result.sumTaxAmount
          }
        }
        if (name === 'currMonthStatistics') {
          this.inStats = this.inDataSource.currMonthStatistics
        }
      }
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
